export default "__VITE_ASSET__D959JTdv__"